import { PageHeader, Space, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { ButtonItem, TableItem, dineroDisabledMask } from "../../../Components/Items";
import { EyeOutlined } from "@ant-design/icons";
import MandarConsignacion from "../InventarioConsignaciones/MandarConsignacion/MandarConsignacion";

moment.locale("es");

class Consignaciones extends Component {
  state = {
    todasConsignaciones: [],
    loading: false,
    modalCancelacion: false,
    modalCancelacionId: null,
    modalEnvios: false,
    modalEnviosId: null
  };
  componentDidMount() {
    this.consultarOrdenes();
  }

  consultarOrdenes() {
    this.setState({ loading: true });
    axios
      .post(
        "consignaciones/selectOrdenes",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.status === 404) {
        } else {
          this.setState({
            todasConsignaciones: res.data.map((value) => {
              return {
                ...value,
                numero: (value.consignacionSerie + ' ' + value.consignacionNumero),
                clienteNombre: value.cliente.persona ? value.cliente.razonSocial : (value.cliente.nombre + ' ' + value.cliente.apellidoPaterno + ' ' + value.cliente.apellidoMaterno),
                clienteRfc: value.cliente.rfc,
                cliente: (value.cliente.persona ? value.cliente.razonSocial : (value.cliente.nombre + ' ' + value.cliente.apellidoPaterno + ' ' + value.cliente.apellidoMaterno)) + " - " + value.cliente.rfc,
                accion: {
                  _id: value._id,
                  dataFactura: !!value.dataFactura,
                  estado: value.estado,
                  estadoCosteo: value.estadoCosteo,
                  servicios: value.servicios,
                  estadoPago: value.estadoPago,
                  facturaGlobal: value.facturaGlobal,
                  factura: value.factura,
                  contado: value.contado,
                  remision: value.remision,
                  cuentasXC: value.cuentasXC,
                  envios: value.envios,
                },
              };
            }),
          });
        }
      });
  }

  agregarConsignacion() {
    this.props.history.push('/panel/agregarConsignacion')
  }

  bajaConsignacion() {
    this.props.history.push('/panel/agregarBajaConsignacion')
  }

  cerrarMandarConsignacion() {
    this.setState({
      modalCorreo: false,
      modalCorreoId: null,
    });
  }

  abrirVistaPrevia(id) {
    this.setState({
      modalCorreo: true,
      modalCorreoId: id,
    });
  }

  render() {
    const isMobile = window.innerWidth <= 1000;
    const columns = [
      {
        title: "Numero",
        dataIndex: "numero",
        responsive: ["md"],
        key: "numero",
        buscar: 'numero',
        width: "7%",
      },
      {
        title: "Proyecto",
        dataIndex: "proyecto",
        responsive: ["md"],
        key: "proyecto",
        sorter: (a, b) => {
          if (a.proyecto.nombre < b.proyecto.nombre) {
            return -1;
          }
          if (a.proyecto.nombre > b.proyecto.nombre) {
            return 1;
          }
          return 0;
        },
        render: (value) => value.nombre,
        width: "16%",
        ellipsis: true,
      },
      {
        title: "Cliente",
        dataIndex: "clienteNombre",
        key: "clienteNombre",
        buscar: "cliente",
        sorter: true,
        render: (_, record) => (
            <div>
                <div style={{ fontSize: "12px", fontWeight: "bold" }}>
                {record.clienteNombre}
                </div>
            </div>
        ),
        width: "16%",
        ellipsis: true,
        },
        {
        title: "RFC",
        dataIndex: "clienteRfc",
        key: "clienteRfc",
        render: (value) => (
            <div style={{ fontSize: "12px" }}>
                {value}
            </div>
        ),
        width: "12%",
        ellipsis: true,
        },
      {
        title: "Fecha",
        dataIndex: "fechaRegistro",
        key: "fechaRegistro",
        sorter: (a, b) => {
          if (moment(a.fechaRegistro) < moment(b.fechaRegistro)) {
            return -1;
          }
          if (moment(a.fechaRegistro) > moment(b.fechaRegistro)) {
            return 1;
          }
          return 0;
        },
        render: (value) => moment(value).locale("es").format("ll"),
        wdith: "13%",
        ellipsis: true,
        align: "center",
      },
      {
        title: "Subtotal / Total",
        dataIndex: "subtotal",
        key: "subtotal",
        sorter: (a, b) => {
          if (a.subtotal < b.subtotal) {
            return -1;
          }
          if (a.subtotal > b.subtotal) {
            return 1;
          }
          return 0;
        },
        render: (_, record) => (
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: "12px", color: "#666", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
              <span>{dineroDisabledMask(record.subtotal)}</span>
               {record.moneda.abreviacion && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda.abreviacion}</span>}

            </div>
            <div style={{ fontSize: "12px", fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
              <span>{dineroDisabledMask(record.total)}</span>
              {record.moneda.abreviacion && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda.abreviacion}</span>}
            </div>
          </div>
        ),
        buscar: "subtotal",
        width: isMobile ? "20%" : "12%",
        ellipsis: true,
        align: "right",
      },
      {
        title: "Total",
        dataIndex: "total",
        key: "total",
        sorter: (a, b) => {
          if (a.total < b.total) {
            return -1;
          }
          if (a.total > b.total) {
            return 1;
          }
          return 0;
        },
        buscar: "total",
        responsive: [],
        width: 0,
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: "22%",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value, index) => {
          let buttons = [];

          buttons.push(
            <Tooltip title="Vista Previa" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                key={`vista-${index}`}
                type="default"
                size="small"
                azul
                icon={<EyeOutlined />}
                onClick={() => this.abrirVistaPrevia(value._id)}
              >
              </ButtonItem>
            </Tooltip>
          );

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];
    return (
      <>
        <PageHeader
          title="Consignaciones"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={ 
          <Space>
             {this.props.permisoDarBajaConsignacion && (
              <ButtonItem
                blanco
                key="bajaConsignacion"
                className="botonAgregar"
                onClick={this.bajaConsignacion.bind(this)}
              >
                Baja Consignacion
              </ButtonItem>
            )}
            {this.props.permisoAgregarConsignacion && (
              <ButtonItem
                key="agregarConsignacion"
                olivo
                onClick={this.agregarConsignacion.bind(this)}
                style={{ fontSize: '14px', padding: '6.4px 15px', height: '32px' }}
              >
                Agregar Consignación
              </ButtonItem>
            )}
           
          </Space>
          }
        />
        <TableItem
          onRow={(record, rowIndex) => {
            return {
              onDoubleClick: (event) => {
                this.props.history.push("/panel/verConsignacion", { id: record._id });
              },
            };
          }}
          loading={this.state.loading}
          size="small"
          dataSource={this.state.todasConsignaciones}
          columns={columns}
          pagination={false}
        />
                <MandarConsignacion
            visible={this.state.modalCorreo}
            id={this.state.modalCorreoId}
            cerrarMandarConsignacion={this.cerrarMandarConsignacion.bind(this)}
          />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    certificada: state.empresa.certificada,
    envios: state.empresa.envios,
    permisoAgregarConsignacion:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "675092cc798d4e0043687246"
      )?.activado,
    permisoDarBajaConsignacion:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6750933f798d4e0043687247"
      )?.activado,
  };
};

export default connect(mapStateToProps)(Consignaciones);
